import { render, staticRenderFns } from "./DownloadFile.vue?vue&type=template&id=33a205c2&scoped=true"
import script from "./js/downloadFile.js?vue&type=script&lang=js&external"
export * from "./js/downloadFile.js?vue&type=script&lang=js&external"
import style0 from "./DownloadFile.vue?vue&type=style&index=0&id=33a205c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a205c2",
  null
  
)

export default component.exports